import { NextPageContext } from 'next'
import {
  AddFieldErrorPayload,
  AddFieldsErrorsPayload,
  ChangeMoodMeterFormFieldPayload,
  ChangeMoodMeterGroupFormFieldPayload,
  ClearFieldErrorPayload,
  GroupFormData,
  LoadMoodMeterGroupPagePayload,
  StartMoodMeterGroupPlotPayload,
  SubmitMoodMeterPlotPayload,
  ValidateMoodMeterGroupFormFieldPayload,
} from './types'

export const SUBMIT_GROUP_MOOD_METER_PLOT = 'SUBMIT_GROUP_MOOD_METER_PLOT'
export const SUBMIT_PERSONAL_MOOD_METER_PLOT = 'SUBMIT_PERSONAL_MOOD_METER_PLOT'
export const CHANGE_MOOD_METER_FORM_FIELD = 'CHANGE_MOOD_METER_FORM_FIELD'
export const ADD_MOOD_METER_FIELDS_ERRORS = 'ADD_MOOD_METER_FIELDS_ERRORS'
export const RESET_MOOD_METER_FORM_DATA = 'RESET_MOOD_METER_FORM_DATA'
export const CLEAR_MOOD_METER_FIELD_ERROR = 'CLEAR_MOOD_METER_FIELD_ERROR'

export const START_MOOD_METER_GROUP_PLOT = 'START_MOOD_METER_GROUP_PLOT'
export const CHANGE_MOOD_METER_GROUP_FORM_FIELD = 'CHANGE_MOOD_METER_GROUP_FORM_FIELD'
export const ADD_MOOD_METER_GROUP_FORM_FIELDS_ERRORS = 'ADD_MOOD_METER_GROUP_FORM_FIELDS_ERRORS'
export const RESET_MOOD_METER_GROUP_FORM_DATA = 'RESET_MOOD_METER_GROUP_FORM_DATA'
export const CLEAR_MOOD_METER_GROUP_FORM_FIELD_ERROR = 'CLEAR_MOOD_METER_GROUP_FIELD_ERROR'
export const VALIDATE_MOOD_METER_GROUP_FORM_FIELD = 'VALIDATE_MOOD_METER_GROUP_FORM_FIELD'
export const ADD_MOOD_METER_GROUP_FORM_FIELD_ERROR = 'ADD_MOOD_METER_GROUP_FORM_FIELD_ERROR'
export const PREDEFINE_MOOD_METER_GROUP_FORM_DATA = 'PREDEFINE_MOOD_METER_GROUP_FORM_DATA'

export const LOAD_MOOD_METER_GROUP_PAGE = 'LOAD_MOOD_METER_GROUP_PAGE'

// Action Interfaces
interface ChangeMoodMeterGroupFormFieldAction {
  type: typeof CHANGE_MOOD_METER_GROUP_FORM_FIELD
  payload: ChangeMoodMeterGroupFormFieldPayload
}

interface ResetMoodMeterGroupFormDataAction {
  type: typeof RESET_MOOD_METER_GROUP_FORM_DATA
}

interface AddGroupFormFieldErrorAction {
  type: typeof ADD_MOOD_METER_GROUP_FORM_FIELD_ERROR
  payload: AddFieldErrorPayload
}

interface AddGroupFormFieldsErrorsAction {
  type: typeof ADD_MOOD_METER_GROUP_FORM_FIELDS_ERRORS
  payload: AddFieldsErrorsPayload
}

interface ClearGroupFormFieldErrorAction {
  type: typeof CLEAR_MOOD_METER_GROUP_FORM_FIELD_ERROR
  payload: ClearFieldErrorPayload
}

interface StartMoodMeterGroupPlotAction {
  type: typeof START_MOOD_METER_GROUP_PLOT
  payload: StartMoodMeterGroupPlotPayload
}

interface ValidateMoodMeterGroupFormFieldAction {
  type: typeof VALIDATE_MOOD_METER_GROUP_FORM_FIELD
  payload: ValidateMoodMeterGroupFormFieldPayload
}

interface ChangeMoodMeterFormFieldAction {
  type: typeof CHANGE_MOOD_METER_FORM_FIELD
  payload: ChangeMoodMeterFormFieldPayload
}

interface PredefineMoodMeterGroupFormDataAction {
  type: typeof PREDEFINE_MOOD_METER_GROUP_FORM_DATA
  payload: Partial<GroupFormData>
}

interface ResetMoodMeterFormDataAction {
  type: typeof RESET_MOOD_METER_FORM_DATA
}

interface AddFieldsErrorsAction {
  type: typeof ADD_MOOD_METER_FIELDS_ERRORS
  payload: AddFieldsErrorsPayload
}

interface ClearFieldErrorAction {
  type: typeof CLEAR_MOOD_METER_FIELD_ERROR
  payload: ClearFieldErrorPayload
}

interface SubmitGroupMoodMeterPlotAction {
  type: typeof SUBMIT_GROUP_MOOD_METER_PLOT
  payload: SubmitMoodMeterPlotPayload
}

interface SubmitPersonalMoodMeterPlotAction {
  type: typeof SUBMIT_PERSONAL_MOOD_METER_PLOT
  payload: SubmitMoodMeterPlotPayload
}

interface LoadMoodMeterGroupPageAction {
  type: typeof LOAD_MOOD_METER_GROUP_PAGE
  payload: LoadMoodMeterGroupPagePayload
}

export type MoodMeterActionTypes =
  | ChangeMoodMeterGroupFormFieldAction
  | ResetMoodMeterGroupFormDataAction
  | AddGroupFormFieldErrorAction
  | AddGroupFormFieldsErrorsAction
  | ClearGroupFormFieldErrorAction
  | StartMoodMeterGroupPlotAction
  | ValidateMoodMeterGroupFormFieldAction
  | ChangeMoodMeterFormFieldAction
  | PredefineMoodMeterGroupFormDataAction
  | ResetMoodMeterFormDataAction
  | AddFieldsErrorsAction
  | ClearFieldErrorAction
  | SubmitGroupMoodMeterPlotAction
  | SubmitPersonalMoodMeterPlotAction
  | LoadMoodMeterGroupPageAction

// Action Creators
export function changeMoodMeterGroupFormField(
  key: keyof GroupFormData,
  value: string | Date | null,
): ChangeMoodMeterGroupFormFieldAction {
  return {
    type: CHANGE_MOOD_METER_GROUP_FORM_FIELD,
    payload: {
      key,
      value,
    },
  }
}

export function resetMoodMeterGroupFormData(): ResetMoodMeterGroupFormDataAction {
  return {
    type: RESET_MOOD_METER_GROUP_FORM_DATA,
  }
}

export function addGroupFormFieldError({
  field,
  error,
}: AddFieldErrorPayload): AddGroupFormFieldErrorAction {
  return {
    type: ADD_MOOD_METER_GROUP_FORM_FIELD_ERROR,
    payload: {
      error,
      field,
    },
  }
}

export function addGroupFormFieldsErrors(
  errors: Record<string, string>,
): AddGroupFormFieldsErrorsAction {
  return {
    type: ADD_MOOD_METER_GROUP_FORM_FIELDS_ERRORS,
    payload: {
      errors,
    },
  }
}

export function clearGroupFormFieldError({
  field,
}: ClearFieldErrorPayload): ClearGroupFormFieldErrorAction {
  return {
    type: CLEAR_MOOD_METER_GROUP_FORM_FIELD_ERROR,
    payload: {
      field,
    },
  }
}

export function startMoodMeterGroupPlot(
  payload: StartMoodMeterGroupPlotPayload,
): StartMoodMeterGroupPlotAction {
  return {
    type: START_MOOD_METER_GROUP_PLOT,
    payload,
  }
}

export function validateMoodMeterGroupFormField({
  field,
  value,
  validations,
}: ValidateMoodMeterGroupFormFieldPayload): ValidateMoodMeterGroupFormFieldAction {
  return {
    type: VALIDATE_MOOD_METER_GROUP_FORM_FIELD,
    payload: {
      field,
      value,
      validations,
    },
  }
}

export function changeMoodMeterFormField(
  key: string,
  value: string | number,
): ChangeMoodMeterFormFieldAction {
  return {
    type: CHANGE_MOOD_METER_FORM_FIELD,
    payload: {
      key: key as ChangeMoodMeterFormFieldPayload['key'],
      value,
    },
  }
}

export function predefineMoodMeterGroupFormData(
  payload: Partial<GroupFormData>,
): PredefineMoodMeterGroupFormDataAction {
  return {
    type: PREDEFINE_MOOD_METER_GROUP_FORM_DATA,
    payload,
  }
}

export function resetMoodMeterFormData(): ResetMoodMeterFormDataAction {
  return {
    type: RESET_MOOD_METER_FORM_DATA,
  }
}

export function addFieldsErrors(errors: Record<string, string>): AddFieldsErrorsAction {
  return {
    type: ADD_MOOD_METER_FIELDS_ERRORS,
    payload: {
      errors,
    },
  }
}

export function clearFieldError(field: string): ClearFieldErrorAction {
  return {
    type: CLEAR_MOOD_METER_FIELD_ERROR,
    payload: {
      field,
    },
  }
}

export function submitGroupMoodMeterPlot(groupId?: string): SubmitGroupMoodMeterPlotAction {
  return {
    type: SUBMIT_GROUP_MOOD_METER_PLOT,
    payload: {
      groupId,
    },
  }
}

export function submitPersonalMoodMeterPlot(groupId?: string): SubmitPersonalMoodMeterPlotAction {
  return {
    type: SUBMIT_PERSONAL_MOOD_METER_PLOT,
    payload: {
      groupId,
    },
  }
}

export function loadMoodMeterGroupPage({
  req,
  shortCode,
}: {
  req?: NextPageContext['req']
  shortCode: string
}): LoadMoodMeterGroupPageAction {
  return {
    type: LOAD_MOOD_METER_GROUP_PAGE,
    payload: {
      req,
      shortCode,
    },
  }
}
